import React, { useState, useEffect } from "react";
// import { Link } from 'react-router-dom/cjs/react-router-dom'
// import ChildPic from "../../../../../assets/images/child-round.png";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useKidListFunctionality from "../../../../customHooks/kidListHook";
import useFirebase from "../../../../../useFirebase";
import { setRuleDataSetUp } from "../../../AxiosRtk/SetRules";
import { setNotificationSetting } from "../../../AxiosRtk/SetRules";
import CommonStatus from "../../Common/CommonStatus";
import useDeviceStatus from "../../../../customHooks/deviceStatusProvider";
import useLangTranslation from "../../../../customHooks/languageProvider";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import Select from "react-select";
import KidImage from "../../../../shared/KidImage/KidImage";
import { useDashboardDataProvider } from "../../../../customHooks/dashboardDataProvider"

const ManageNotifications = () => {
  const history = useHistory();
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [kid, setKid] = useState(null);
  const [device, setDevice] = useState("");
  const [toggleData, setToggleData] = useState({ push: 0, email: 0 });
  // const [manageNotification, setManageNotification] = useState(null);
  const { getLangTranslation } = useLangTranslation();
  const dispatch = useDispatch();
  // console.log("toggleData ==>>", toggleData);
  const { postCollectionData, createCollectionData, getCollectionData } =
    useFirebase();

  const { handleDeviceSelection } = useDashboardDataProvider();

  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );

  function callFirebase(payload) {
    if (setRulesData) {
      postCollectionData(selectedDeviceData?.ID, { managenotification: payload });
    } else {
      createCollectionData(selectedDeviceData?.ID, { managenotification: payload });
    }
    getCollectionData(selectedDeviceData?.ID);
  }

  const [notificationList, setNotificationList] = useState([
    {
      key: "_child_open_forbidden_website",
      dbKey: "is_child_open_forbidden_website",
      langKey: "MANAGE_NOTIFICATION_CHILD_OPEN_FORBIDDEN_WEBSITE",
      text: "Child tried to open a forbidden website",
      isChecked: 0,
    },
    {
      key: "_child_open_unrecommended_website",
      dbKey: "is_child_open_unrecommended_website",
      langKey: "MANAGE_NOTIFICATION_CHILD_OPEN_UNRECOMMEND_WEBSITE",
      text: "Child opened unrecommended website",
      isChecked: 0,
    },
    {
      key: "_child_device_blocked_on_schedule",
      dbKey: "is_child_device_blocked_on_schedule",
      langKey: "MANAGE_NOTIFICATION_CHILD_DEVICE_BLOCKED_SCHEDULE",
      text: "Child's device was blocked on schedule",
      isChecked: 0,
    },
    {
      key: "_child_device_on_time_limit_was_reached",
      dbKey: "is_child_device_on_time_limit_was_reached",
      langKey: "MANAGE_NOTIFICATION_CHILD_DEVICE_BLOCKED_TIME_LIMIT_REACHED",
      text: "Child's device has been blocked: time limit reached",
      isChecked: 0,
    },
    {
      key: "_child_used_device_over_limit",
      dbKey: "is_child_used_device_over_limit",
      langKey: "MANAGE_NOTIFICATION_CHILD_DEVICE_USED_OVER_LIMIT",
      text: "Child used his/her device over limit",
      isChecked: 0,
    },
    {
      key: "_child_tried_forbidden_app",
      dbKey: "is_child_tried_forbidden_app",
      langKey: "MANAGE_NOTIFICATION_CHILD_TRIED_USE_FORBIDDEN_APP",
      text: "Child tried to use a forbidden app",
      isChecked: 0,
    },
    {
      key: "_child_uninstall_kaspersky_safe_kids",
      dbKey: "is_child_uninstall_kaspersky_safe_kids",
      langKey: "MANAGE_NOTIFICATION_CHILD_TRIED_UNISTALL_KIDO_APP",
      text: "Child tried to uninstall Kido Protect app",
      isChecked: 0,
    },
    {
      key: "_new_app_found_on_child_device",
      dbKey: "is_new_app_found_on_child_device",
      langKey: "MANAGE_NOTIFICATION_NEW_APP_FOUND_ON_CHILD_DEVICE",
      text: "New app was found on your child's device",
      isChecked: 0,
    },
    {
      key: "_norton_family_turned_off_any_of_child_devices",
      dbKey: "is_norton_family_turned_off_any_of_child_devices",
      langKey: "MANAGE_NOTIFICATION_KIDO_APP_TURNED_OFF_ON_ANY_KID_DEVICE",
      text: "Kido Protect is turned off on your child's device",
      isChecked: 0,
    },
    {
      key: "_child_searched_unsafe_video_on_youtube",
      dbKey: "is_child_searched_unsafe_video_on_youtube",
      langKey: "MANAGE_NOTIFICATION_CHILD_SEARCHED_UNSAFE_VIDEO_YOUTUBE",
      text: "Child has searched for unsafe videos on YouTube",
      isChecked: 0,
    },
    {
      key: "_child_left_the_allowed_area",
      dbKey: "is_child_left_the_allowed_area",
      langKey: "MANAGE_NOTIFICATION_CHILD_LEFT_ALLOWED_AREA",
      text: "Child had left the allowed area",
      isChecked: 0,
    },
    {
      key: "_child_returned_allowed_area",
      dbKey: "is_child_returned_allowed_area",
      langKey: "MANAGE_NOTIFICATION_CHILD_RETURNED_ALLOWED_AREA",
      text: "Child returned to the allowed area",
      isChecked: 0,
    },
    {
      key: "_child_device_battery_level_critical",
      dbKey: "is_child_device_battery_level_critical",
      langKey: "MANAGE_NOTIFICATION_CHILD_DEVICE_BATTERY_CRITICAL",
      text: "Child's battery level is critical",
      isChecked: 0,
    },
    {
      key: "_child_ignore_warning_when_accessing_blocked_site",
      dbKey: "is_child_ignore_warning_when_accessing_blocked_site",
      langKey: "MANAGE_NOTIFICATION_CHILD_IGNORE_WARNING_ACCESS_BLOCKED_SITE",
      text: "Child ignored a warning when accessing a unrecommended app",
      isChecked: 0,
    },
    {
      key: "_child_install_app_that_block_norton_family_monitoring",
      dbKey: "is_norton_family_turned_off_any_of_child_devices",
      langKey: "MANAGE_NOTIFICATION_KID_INSTALL_APP_THAT_BLOCK_KIDO_MONITORING",
      text: "Your child installed an app that blocks Kido Protect monitoring",
      isChecked: 0,
    },
    {
      key: "_permission_disabled",
      dbKey: "is_permission_disabled",
      langKey: "MANAGE_NOTIFICATION_KID_DISABLED_IMPORTANCE_PERMISSION",
      text: "Important permission was disabled on the child's device",
      isChecked: 0,
    },
    {
      key: "install_a_browser_that_can_not_monitor",
      dbKey: "install_a_browser_that_can_not_monitor",
      langKey: "MANAGE_NOTIFICATION_CHILD_INSTALLED_BROWSER_CAN_NOT_MONITORED",
      text: "Child installed a browser that cannot be monitored",
      isChecked: 0,
    },
    {
      key: "nudity_detected",
      dbKey: "nudity_detected",
      langKey: "MANAGE_NOTIFICATION_NUDITY_DETECTED_CHILD_DEVICE",
      text: "Nudity content detected on child's device",
      isChecked: 0,
    },
    {
      key: "bad_word_tapped",
      dbKey: "bad_word_tapped",
      langKey: "MANAGE_NOTIFICATION_BAD_WORD_TAPPED_CHILD_DEVICE",
      text: "Keyword typed by your child",
      isChecked: 0,
    },
    {
      key: "bad_word_searched",
      dbKey: "bad_word_searched",
      langKey: "MANAGE_NOTIFICATION_BAD_WORD_SEARCHED_CHILD_DEVICE",
      text: "Keyword searched by your child",
      isChecked: 0,
    },
    {
      key: "kid_received_a_call",
      dbKey: "kid_received_a_call",
      langKey: "MANAGE_NOTIFICATION_KID_RECEIVE_CALL",
      text: "Child received a call",
      isChecked: 0,
    },
    {
      key: "kid_received_a_sms",
      dbKey: "kid_received_a_sms",
      langKey: "MANAGE_NOTIFICATION_KID_RECEIVE_SMS",
      text: "Child received an SMS",
      isChecked: 0,
    },
    {
      key: "kid_sent_a_call",
      dbKey: "kid_sent_a_call",
      langKey: "MANAGE_NOTIFICATION_KID_SEND_CALL",
      text: "Child made a call",
      isChecked: 0,
    },
    {
      key: "kid_send_a_sms",
      dbKey: "kid_send_a_sms",
      langKey: "Child sent an SMS",
      text: "Child sent an SMS",
      isChecked: 0,
    },
    {
      key: "kid_requested_an_authorization_on_a_web",
      dbKey: "kid_requested_an_authorization_on_a_web",
      langKey: "MANAGE_NOTIFICATION_KID_REQUESTED_AUTHORIZATION_FOR_WEBSITE",
      text: "Child requested an authorization for a web site",
      isChecked: 0,
    },
    {
      key: "kid_requested_an_authorization_on_app",
      dbKey: "kid_requested_an_authorization_on_app",
      langKey: "MANAGE_NOTIFICATION_KID_REQUESTED_AUTHORIZATION_APP",
      text: "Child requested an authorization for an app",
      isChecked: 0,
    },
    {
      key: "kid_requested_extra_time_on_device",
      dbKey: "kid_requested_extra_time_on_device",
      langKey: "MANAGE_NOTIFICATION_KID_REQUESTED_EXTRA_TIME",
      text: "Child requested extra time for his device",
      isChecked: 0,
    },
    {
      key: "_developer_mode_enable",
      dbKey: "is_developer_mode_enable",
      langKey: "MANAGE_NOTIFICATION_CHILD_ENABLED_DEVELOPER_MODE",
      text: "Child enabled developer mode",
      isChecked: 0,
    },
    {
      key: "notification_by_using_app",
      dbKey: "notification_by_using_app",
      langKey: "MANAGE_NOTIFICATIONS_NOTIFICATION_BY_USING_APP",
      text: "Child used an app",
      isChecked: 0
    },
    {
      key: "checkInNotification",
      dbKey: "checkInNotification",
      langKey: "MANAGE_NOTIFICATIONS_CHECK_IN",
      text: "Child did check in",
      isChecked: 0,
    },
    {
      key: "childUploadFile",
      dbKey: "childUploadFile",
      langKey: "MANAGE_NOTIFICATIONS_CHILD_GALLERY_FILE_UPLOAD",
      text: "New files detected on Child Gallery",
      isChecked: 0
    },
    {
      key: "kidNewMessageSocialMedia",
      dbKey: "kidNewMessageSocialMedia",
      langKey: "MANAGE_NOTIFICATIONS_NEW_MESSAGE_ON_SOCIAL_MEDIA",
      text: "New message on social media",
      isChecked: 0
    },
    {
      key: "kidThreatFbMessage",
      dbKey: "kidThreatFbMessage",
      langKey: "MANAGE_NOTIFICATIONS_THREAT_FB_MESSAGE",
      text: "Threat detected on social app",
      isChecked: 0
    },
    {
      key: "kidThreatScreenshotMessage",
      dbKey: "kidThreatScreenshotMessage",
      langKey: "MANAGE_NOTIFICATIONS_THREAT_SS_MESSAGE",
      text: "Threat detected on screenshot text",
      isChecked: 0
    },
    {
      key: "drugImageDetected",
      dbKey: "drugImageDetected",
      langKey: "MANAGE_NOTIFICATIONS_DRUG_IMAGE_DETECTED",
      text: "Drugs or Violence or Guns images detected",
      isChecked: 0
    },
    // {
    //   key: "kidOpenTikTok",
    //   dbKey: "kidOpenTikTok",
    //   langKey: "MANAGE_NOTIFICATIONS_CHILD_OPEN_TIKTOK_APP",
    //   text: "Child open social app",
    //   isChecked: 0
    // },
    {
      key: "sosChild",
      dbKey: "sosChild",
      langKey: "MANAGE_NOTIFICATIONS_SOS_FROM_CHILD",
      text: "SOS from your child",
      isChecked: 0
    }
  ]);

  // {key: '_child_uninstall_kido_protect', text: "Child tried to uninstall Kido Protect app", isChecked: false},
  // _norton_family_turned_off_any_of_child_devices
  // _child_uninstall_kaspersky_safe_kids

  // console.log(notificationList.length);
  const { getImage } = useKidListFunctionality();
  const { kidList, selectedKidId, kidDevicesList, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);

  const { setRulesData } = useSelector(({ setRules }) => setRules);
  // console.log("setRulesData ==>>", setRulesData);

  useEffect(() => {
    if (kidList && selectedKidId) {
      const kid = kidList?.find(
        (item) => parseInt(item?.ID) === parseInt(selectedKidId)
      );
      setKid(kid);
    }
  }, [kidList, selectedKidId]);
  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  // useEffect(() => {
  //   if (selectedDeviceData) {
  //     const jsonDevice = JSON.parse(selectedDeviceData);
  //     setDevice(jsonDevice?.ID);
  //   }
  // }, [selectedDeviceData]);

  useEffect(() => {
    if (selectedDeviceData?.ID) {
      getDeviceStatusData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData?.ID]);

  useEffect(() => {
    if (selectedDeviceData?.ID) {
      getCollectionData(selectedDeviceData?.ID);
    } else {
      dispatch(setRuleDataSetUp(null));
    }
  }, [selectedDeviceData?.ID]);

  useEffect(() => {
    if (setRulesData) {
      const manageNotificationData = setRulesData?.managenotification;
      const notificationListTemp = [...notificationList];

      if (manageNotificationData) {
        notificationListTemp?.forEach((item, index) => {
          notificationListTemp[index]["isChecked"] =
            manageNotificationData[item["key"]] ?? 0;
        });

        const tempToggleData = { ...toggleData };
        tempToggleData["push"] =
          manageNotificationData?._push_notification ?? 0;
        tempToggleData["email"] =
          manageNotificationData?._email_notification ?? 0;

        setToggleData(tempToggleData);
      }

      setNotificationList(notificationListTemp);
    }
  }, [setRulesData]);

  // useEffect(() => {
  //     if (manageNotification) {
  //         console.log(manageNotification)
  //     }
  // }, [manageNotification])

  function handleItemChange(e) {
    const { name, checked } = e.target; // No need to extract `id` here
    const notificationListTemp = [...notificationList];

    if (name === "SELECT_ALL") {
      // Update all items based on the 'checked' status of "SELECT_ALL"
      notificationListTemp.forEach((item) => {
        item.isChecked = checked ? 1 : 0; // Set to 1 for select, 0 for unselect
      });
    } else {
      notificationListTemp.forEach((item) => {
        if (item.key === name) {
          item.isChecked = checked ? 1 : 0; // Update specific item
        }
      });
    }
    setNotificationList(notificationListTemp);
  }


  function handleSave() {
    const collectionPayload = notificationList?.reduce((acc, item) => {
      acc[item?.key] = item?.isChecked;
      return acc;
    }, {});

    collectionPayload["_push_notification"] = toggleData?.push;
    collectionPayload["_email_notification"] = toggleData?.email;

    const payload = notificationList?.reduce((acc, item) => {
      acc[item?.dbKey] = item?.isChecked;
      return acc;
    }, {});

    payload["is_push_notification"] = toggleData?.push;
    payload["is_email_notification"] = toggleData?.email;
    payload["kidId"] = [selectedKidId];
    payload["deviceId"] = [selectedDeviceData?.ID];

    // console.log(collectionPayload);
    // console.log(payload);

    callFirebase(collectionPayload);

    setTimeout(() => {
      setNotificationSetting(payload)
        .then((res) => {
          console.log(res?.data?.message);
          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: "Data updated successfully",
              message: "DATA_FETCH",
            })
          );
        })
        .catch((err) => {
          console.log(err?.response?.data?.message);
        });
    }, 1500);
  }

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap align-items-center separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  {/* <Link to="/" className="text-blue-900 fs-5"> */}
                  <div
                    className="d-flex text-blue-900 fs-4 c-pointer"
                    onClick={() => history.goBack()}
                  >
                    <span className="">
                      <i className="icon-arrow-left" />
                    </span>
                    <h3 className="text-blue-900 mb-0">
                      {getLangTranslation(
                        "MANAGE_NOTIFICATIONS",
                        "Manage notifications"
                      )}
                    </h3>
                  </div>
                  {/* </Link> */}
                </div>
              </div>
            </div>
            <div className="list-item">
              {/* <span className="icon-wrap icon-rounded me-2 p-0">
                <img src={getImage(kid?.image, kid?.gender)} alt="" />
              </span> */}
              <KidImage imageUrl={kid?.image} gender={kid?.gender} />
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{kid?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item col-12 col-md-3">
              <Select
                className="custom-select col-lg-6"
                classNamePrefix="custom-select"
                placeholder="Select Device"
                options={deviceOptions}
                value={
                  deviceOptions?.find(
                    (item) => item?.value === selectedDeviceData?.ID
                  ) || ""
                }
                onChange={handleDeviceSelection}
                isSearchable={false}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div
            className="alert alert-success alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold"
            role="alert"
          >
            <i className="icon-info-one fs-5" />
            {getLangTranslation(
              "MANAGE_NOTIFICATION_YOU_CAN_NOTIFIED_WHICH_CHILD_ACTION",
              "You can set the way you want to be notified and which of your child's actions you want to be notified of."
            )}
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
          <div className="d-flex flex-wrap align-items-center gap-9 ">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                name="SELECT_ALL"
                id="SELECT_ALL"
                // checked={
                //   notificationList?.filter((item) => item?.isChecked !== 1)
                //     ?.length < 1
                // }
                checked={
                  notificationList?.every((item) => item.isChecked === 1) // True only if all items are checked
                }
                onChange={handleItemChange}
              />
              <label className="form-check-label" htmlFor="SELECT_ALL">
                {getLangTranslation(
                  "MANAGE_NOTIFICATION_SELECT_ALL",
                  "Select All"
                )}
              </label>
            </div>
            <div className="form-check form-switch">
              <label className="form-check-label" htmlFor="pushNotification">
                {getLangTranslation(
                  "MANAGE_NOTIFICATION_PUSH_NOTIFICATION",
                  "Push notifications"
                )}
              </label>
              <input
                className="form-check-input"
                id="pushNotification"
                type="checkbox"
                role="switch"
                checked={toggleData?.push || 0}
                onChange={(e) => {
                  setToggleData({
                    ...toggleData,
                    push: e.target.checked ? 1 : 0,
                  });
                }}
              />
            </div>
            <div className="form-check form-switch">
              <label className="form-check-label" htmlFor="emailNotification">
                {getLangTranslation(
                  "MANAGE_NOTIFICATION_EMAIL_NOTIFICATION",
                  "Email notifications"
                )}
              </label>
              <input
                className="form-check-input"
                id="emailNotification"
                type="checkbox"
                role="switch"
                checked={toggleData?.email || 0}
                onChange={(e) => {
                  setToggleData({
                    ...toggleData,
                    email: e.target.checked ? 1 : 0,
                  });
                }}
              />
            </div>
            <button className="btn btn-primary ms-auto" onClick={handleSave}>
              <span className="btn-upper-case">
                {getLangTranslation("SAVE", "Save")}
              </span>
            </button>
          </div>
          <hr className="my-6" />
          <div className="row">
            {notificationList?.map((item, index) => {
              return (
                <div className="col-md-6" key={index}>
                  <div className="form-check mb-6">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name={item?.key}
                      id={item?.key}
                      checked={item?.isChecked}
                      onChange={handleItemChange}
                    />
                    <label className="form-check-label" htmlFor={item?.key}>
                      {getLangTranslation(item?.langKey)}
                    </label>
                  </div>
                </div>
              );
            })}
          </div>
          {/* <div className='row'>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="forbiddenWebsite" value="option1" />
                                <label className="form-check-label" htmlFor="forbiddenWebsite">
                                    Child tried to open a forbidden website
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="unrecommendedWebsite" value="option1" />
                                <label className="form-check-label" htmlFor="unrecommendedWebsite">
                                    Child opened unrecommended website
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="blockedOnSchedule" value="option1" />
                                <label className="form-check-label" htmlFor="blockedOnSchedule">
                                    Child's device was blocked on schedule
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="timeLimitReached" value="option1" />
                                <label className="form-check-label" htmlFor="timeLimitReached">
                                    Child's device has been blocked: time limit reached
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="deviceOverLimit" value="option1" />
                                <label className="form-check-label" htmlFor="deviceOverLimit">
                                    Child used his/her device over limit
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="forbiddenApp" value="option1" />
                                <label className="form-check-label" htmlFor="forbiddenApp">
                                    Child tried to use a forbidden app
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="uninstallKidoProtect" value="option1" />
                                <label className="form-check-label" htmlFor="uninstallKidoProtect">
                                    Child tried to uninstall Kido Protect app
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id=" NewAppFound" value="option1" />
                                <label className="form-check-label" htmlFor=" NewAppFound">
                                    New app was found on your child's device
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="unsafeVideosOnYouTube" value="option1" />
                                <label className="form-check-label" htmlFor="unsafeVideosOnYouTube">
                                    Child has searched for unsafe videos on YouTube
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="leftAllowedArea" value="option1" />
                                <label className="form-check-label" htmlFor="leftAllowedArea">
                                    Child had left the allowed area
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="returnedAllowedArea" value="option1" />
                                <label className="form-check-label" htmlFor="returnedAllowedArea">
                                    Child returned to the allowed area
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="batteryLevelCritical" value="option1" />
                                <label className="form-check-label" htmlFor="batteryLevelCritical">
                                    Child's device battery level is critical
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="accessingUnrecommendedApp" value="option1" />
                                <label className="form-check-label" htmlFor="accessingUnrecommendedApp">
                                    Child ignored a warning when accessing a unrecommended app
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="KidoProtectTurnedOff" value="option1" />
                                <label className="form-check-label" htmlFor="KidoProtectTurnedOff">
                                    Kido Protect is turned off on your child's device
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="appBlocksKidoProtectMonitoring" value="option1" />
                                <label className="form-check-label" htmlFor="appBlocksKidoProtectMonitoring">
                                    Your child installed an app that blocks Kido Protect monitoring
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="permissionDisabled" value="option1" />
                                <label className="form-check-label" htmlFor="permissionDisabled">
                                    Important permission was disabled on the child's device
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="browserCannotBeMonitored" value="option1" />
                                <label className="form-check-label" htmlFor="browserCannotBeMonitored">
                                    Child installed a browser that cannot be monitored
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="NudityContentDetected" value="option1" />
                                <label className="form-check-label" htmlFor="NudityContentDetected">
                                    Nudity content detected on child's device
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="KeywordTypedChild" value="option1" />
                                <label className="form-check-label" htmlFor="KeywordTypedChild">
                                    Keyword typed by your child
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="KeywordSearchedChild" value="option1" />
                                <label className="form-check-label" htmlFor="KeywordSearchedChild">
                                    Keyword searched by your child
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="ChildReceivedCall" value="option1" />
                                <label className="form-check-label" htmlFor="ChildReceivedCall">
                                    Child received a call
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="ChildReceivedSMS" value="option1" />
                                <label className="form-check-label" htmlFor="ChildReceivedSMS">
                                    Child received an SMS
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="ChildMadeCall" value="option1" />
                                <label className="form-check-label" htmlFor="ChildMadeCall">
                                    Child made a call
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="ChildSentSMS" value="option1" />
                                <label className="form-check-label" htmlFor="ChildSentSMS">
                                    Child sent an SMS
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id=" ChildRequestedAuthorizationWebsite" value="option1" />
                                <label className="form-check-label" htmlFor=" ChildRequestedAuthorizationWebsite">
                                    Child requested an authorization for a web site
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="ChildRequestedAuthorizationApp" value="option1" />
                                <label className="form-check-label" htmlFor="ChildRequestedAuthorizationApp">
                                    Child requested an authorization for an app
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id=" ChildRequestedExtraTime" value="option1" />
                                <label className="form-check-label" htmlFor=" ChildRequestedExtraTime">
                                    Child requested extra time for his device
                                </label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-check mb-6">
                                <input className="form-check-input" type="checkbox" name="time" id="ChildEnabledDeveloperMode" value="option1" />
                                <label className="form-check-label" htmlFor="ChildEnabledDeveloperMode">
                                    Child enabled developer mode
                                </label>
                            </div>
                        </div>
                    </div> */}
        </div>
      </div>
    </>
  );
};

export default ManageNotifications;
